import List from './list'
import { toJS, action } from 'mobx'
import { Get, Post, Delete } from '../utils/request'
import hasError from './request-message'

export default class GlobalBlocklistStore extends List {
  url = '/api/admin/global-blocklist'

  constructor(filters = {}) {
    super()
    this.perPage = 50
    this.order = 'desc'
    this.orderBy = 'id'
    this.itemsField= 'globalBlocklists'
    this.filters = filters
    this.getList().then()
  }

  @action
  async add (domains) {
    const response = await Post(this.url, { domains })
    const { errorCode, message } = response
    if (!hasError(!errorCode, message, 'Domains added to blocklist')) {
      this.getList().then()
      return true
    }
    return false
  }

  @action
  async remove (id) {
    const response = await Delete(`${this.url}/${id}`, {})
    const { errorCode, message } = response
    if (!hasError(!errorCode, message, 'Domain removed from blocklist')) {
      this.getList().then()
      return true
    }
    return false
  }
}
